function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1976(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29.56,
    height: 16.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9835294117647058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 8.36,
    fontFamily: "Arial"
  }, "\n        Lake_of_the_Woods\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.72,
    width: 29.56,
    height: 18.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 25.78,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.84,
    width: 29.56,
    height: 22.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 45.900000000000006,
    fontFamily: "Arial"
  }, "\n        Red_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.96,
    width: 29.56,
    height: 22.23,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 68.075,
    fontFamily: "Arial"
  }, "\n        Mahnomen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.19,
    width: 29.56,
    height: 27.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 92.835,
    fontFamily: "Arial"
  }, "\n        Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.48,
    width: 29.56,
    height: 30.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.222857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 121.92,
    fontFamily: "Arial"
  }, "\n        Kittson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 137.36,
    width: 29.56,
    height: 34.09,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2844444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 154.40500000000003,
    fontFamily: "Arial"
  }, "\n        Big_Stone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 171.45,
    width: 29.56,
    height: 34.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.956
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 188.52999999999997,
    fontFamily: "Arial"
  }, "\n        Clearwater\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 205.61,
    width: 29.56,
    height: 34.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.926666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 223.09500000000003,
    fontFamily: "Arial"
  }, "\n        Wilkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.58,
    width: 29.56,
    height: 36.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.222857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 258.73,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 276.88,
    width: 29.56,
    height: 36.91,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 295.335,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 313.79,
    width: 29.56,
    height: 42.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.926666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 335.11,
    fontFamily: "Arial"
  }, "\n        Norman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.43,
    width: 29.56,
    height: 45.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.222857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 379.025,
    fontFamily: "Arial"
  }, "\n        Kanabec\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 401.62,
    width: 29.56,
    height: 47.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 425.44,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.26,
    width: 29.56,
    height: 48.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 473.675,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 498.08,
    width: 29.56,
    height: 48.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.926666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 522.545,
    fontFamily: "Arial"
  }, "\n        Roseau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 547.01,
    width: 29.56,
    height: 49.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.222857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 571.635,
    fontFamily: "Arial"
  }, "\n        Stevens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 596.27,
    width: 29.56,
    height: 51.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.273846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 622.0699999999999,
    fontFamily: "Arial"
  }, "\n        Lac_qui_Parle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 647.87,
    width: 29.56,
    height: 52.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.78,
    y: 673.9350000000001,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 0,
    width: 38.09,
    height: 42.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.348333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.605000000000004,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.64,
    y: 0,
    width: 38.1,
    height: 42.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.69,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Pipestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.74,
    y: 0,
    width: 38.24,
    height: 42.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.373333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.86,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Wadena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.98,
    y: 0,
    width: 38.62,
    height: 42.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.517142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.29,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Hubbard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.6,
    y: 0,
    width: 38.62,
    height: 42.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.91,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.22,
    y: 0,
    width: 39.27,
    height: 42.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.854000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.855,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.49,
    y: 0,
    width: 39.65,
    height: 42.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.95625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.315,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Watonwan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.14,
    y: 0,
    width: 40.25,
    height: 42.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.265,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Swift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.39,
    y: 0,
    width: 41.35,
    height: 42.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.065,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Pennington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.75,
    y: 0,
    width: 41.36,
    height: 42.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8933333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.43,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Aitkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.11,
    y: 0,
    width: 43.37,
    height: 42.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.035714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.795,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.48,
    y: 0,
    width: 44.41,
    height: 42.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.816666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.685,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Yellow_Medicine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.89,
    y: 0,
    width: 46.78,
    height: 42.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.28,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Cottonwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.67,
    y: 0,
    width: 46.78,
    height: 42.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.041666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.06,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Sibley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.45,
    y: 0,
    width: 47.66,
    height: 42.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.840909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.2800000000001,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Koochiching\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.11,
    y: 0,
    width: 47.89,
    height: 42.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.28125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.0550000000001,
    y: 21.125,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 42.25,
    width: 48.38,
    height: 45.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.506
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 64.78,
    fontFamily: "Arial"
  }, "\n        Mille_Lacs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 87.31,
    width: 48.38,
    height: 45.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.626666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 110.19,
    fontFamily: "Arial"
  }, "\n        Waseca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 133.07,
    width: 48.38,
    height: 46.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.5475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 156.165,
    fontFamily: "Arial"
  }, "\n        Pine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 179.27,
    width: 48.38,
    height: 46.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.627142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 202.465,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 225.66,
    width: 48.38,
    height: 47.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.718571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 249.175,
    fontFamily: "Arial"
  }, "\n        Wabasha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 272.69,
    width: 48.38,
    height: 48.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.063333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 297.165,
    fontFamily: "Arial"
  }, "\n        Isanti\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 321.64,
    width: 48.38,
    height: 50.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.063333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 347.005,
    fontFamily: "Arial"
  }, "\n        Meeker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 372.37,
    width: 48.38,
    height: 51.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.911428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 397.895,
    fontFamily: "Arial"
  }, "\n        Redwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 423.42,
    width: 48.38,
    height: 53.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 450.015,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 476.61,
    width: 48.38,
    height: 54.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 504.015,
    fontFamily: "Arial"
  }, "\n        Renville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 531.42,
    width: 48.38,
    height: 55.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.063333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 559.3199999999999,
    fontFamily: "Arial"
  }, "\n        Nobles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 587.21,
    width: 48.38,
    height: 56.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.375555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 615.36,
    fontFamily: "Arial"
  }, "\n        Faribault\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.56,
    y: 643.52,
    width: 48.38,
    height: 56.48,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.911428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.75,
    y: 671.76,
    fontFamily: "Arial"
  }, "\n        Chisago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 42.25,
    width: 51.53,
    height: 53.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.44125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.705,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Fillmore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.47,
    y: 42.25,
    width: 51.57,
    height: 53.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.255,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Benton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.03,
    y: 42.25,
    width: 52.9,
    height: 53.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 207.48,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Todd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.93,
    y: 42.25,
    width: 53.52,
    height: 53.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.68375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.69,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Le_Sueur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.45,
    y: 42.25,
    width: 53.81,
    height: 53.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.941111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.355,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Sherburne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.26,
    y: 42.25,
    width: 57.59,
    height: 53.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.68375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.055,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Nicollet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.85,
    y: 42.25,
    width: 58.59,
    height: 53.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.3675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.14500000000004,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Lyon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.44,
    y: 42.25,
    width: 58.73,
    height: 53.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.911666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.805,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.17,
    y: 42.25,
    width: 59.1,
    height: 53.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.911666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.7199999999999,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Becker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.27,
    y: 42.25,
    width: 62.26,
    height: 53.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.911666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.4,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        McLeod\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.52,
    y: 42.25,
    width: 62.48,
    height: 53.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.68375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.76,
    y: 68.985,
    fontFamily: "Arial"
  }, "\n        Beltrami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 95.72,
    width: 63.82,
    height: 52.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 121.91,
    fontFamily: "Arial"
  }, "\n        Morrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 148.1,
    width: 63.82,
    height: 52.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 174.33499999999998,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 200.56,
    width: 63.82,
    height: 53.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.961666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 227.445,
    fontFamily: "Arial"
  }, "\n        Steele\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 254.33,
    width: 63.82,
    height: 54.97,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.852857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 281.815,
    fontFamily: "Arial"
  }, "\n        Carlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 309.3,
    width: 63.82,
    height: 55.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.062000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 336.95500000000004,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 364.62,
    width: 63.82,
    height: 63.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.7925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 396.205,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 427.79,
    width: 63.82,
    height: 64.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 459.995,
    fontFamily: "Arial"
  }, "\n        Carver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 492.2,
    width: 63.82,
    height: 67.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.091111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 525.9449999999999,
    fontFamily: "Arial"
  }, "\n        Kandiyohi\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 559.69,
    width: 63.82,
    height: 69.32,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 594.35,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.94,
    y: 629.01,
    width: 63.82,
    height: 70.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.85,
    y: 664.505,
    fontFamily: "Arial"
  }, "\n        Freeborn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.76,
    y: 95.72,
    width: 64.45,
    height: 75.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.98499999999999,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Goodhue\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.21,
    y: 95.72,
    width: 65.26,
    height: 75.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.251111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.84,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Crow_Wing\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.47,
    y: 95.72,
    width: 65.41,
    height: 75.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.3525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.175,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Rice\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.88,
    y: 95.72,
    width: 67.65,
    height: 75.38,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.705,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Itasca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.53,
    y: 95.72,
    width: 71.68,
    height: 75.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.336000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.37,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Mower\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.21,
    y: 95.72,
    width: 72.41,
    height: 75.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.1025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.415,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 548.63,
    y: 95.72,
    width: 73.1,
    height: 75.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.183333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.18,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Winona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.73,
    y: 95.72,
    width: 78.27,
    height: 75.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.563333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.865,
    y: 133.41,
    fontFamily: "Arial"
  }, "\n        Wright\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.76,
    y: 171.1,
    width: 88.55,
    height: 69.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.035,
    y: 205.89999999999998,
    fontFamily: "Arial"
  }, "\n        Otter_Tail\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.76,
    y: 240.7,
    width: 88.55,
    height: 72.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.035,
    y: 277.175,
    fontFamily: "Arial"
  }, "\n        Blue_Earth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.76,
    y: 313.65,
    width: 88.55,
    height: 112.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.035,
    y: 369.945,
    fontFamily: "Arial"
  }, "\n        Olmsted\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.76,
    y: 426.24,
    width: 88.55,
    height: 135.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.035,
    y: 494.14,
    fontFamily: "Arial"
  }, "\n        Stearns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.76,
    y: 562.04,
    width: 88.55,
    height: 137.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.035,
    y: 631.02,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.31,
    y: 171.1,
    width: 133.05,
    height: 148.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.610000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.83500000000004,
    y: 245.105,
    fontFamily: "Arial"
  }, "\n        Anoka\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.36,
    y: 171.1,
    width: 142.84,
    height: 148.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.80666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.78000000000003,
    y: 245.105,
    fontFamily: "Arial"
  }, "\n        Dakota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.2,
    y: 171.1,
    width: 193.8,
    height: 148.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.455454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.1,
    y: 245.105,
    fontFamily: "Arial"
  }, "\n        Saint_Louis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.31,
    y: 319.11,
    width: 150.57,
    height: 380.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.595,
    y: 509.555,
    fontFamily: "Arial"
  }, "\n        Ramsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.88,
    y: 319.11,
    width: 319.12,
    height: 380.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.44,
    y: 509.555,
    fontFamily: "Arial"
  }, "\n        Hennepin\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1976);
export default __webpack_public_path__ + "static/media/1976.cdffcc3e622f6ef263cc401fca78e121.svg";
export { ForwardRef as ReactComponent };